import { Component } from "@angular/core";
import { Platform, NavParams, ViewController } from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";

@Component({
  selector: "add-cp-user-info-modal",
  templateUrl: "add-cp-user-info-modal.html",
  providers: [SummaryServiceProvider],
})
export class AddUserCpModalComponent {
  cpId;
  cpName;
  username: any;
  firstName: any;
  lastName: any;
  status: any;
  password: any;
  merchantStatusList = [
    { value: "ACTIVE", id: "ACTIVE" },
    { value: "NOT_ACTIVE", id: "NOT_ACTIVE" },
  ];
  model: any = {};

  constructor(
    public platform: Platform,
    public params: NavParams,
    public summaryService: SummaryServiceProvider,
    public viewCtrl: ViewController
  ) {
    this.cpId = this.params.get("data");
    console.log("Merchant user data", this.cpId);
  }

  compareFn(a, b) {
    return a && b ? a === b : a === b;
  }

  async addBasicInfo() {
    let payload: any = {
      collectionPointDto: {
        id: this.cpId,
      },
      authority: ["ROLE_MERCHANT_STATION"],
    };
    if (
      !this.model.username ||
      !this.model.password ||
      !this.model.status ||
      !this.model.firstName ||
      !this.model.lastName
    ) {
      alert("Fill All data");
      return;
    }
    payload.username = this.model.username;
    payload.password = this.model.password;
    payload.enabled = this.model.status == "ACTIVE" ? true : "false";
    payload.firstName = this.model.firstName;
    payload.lastName = this.model.lastName;

    if (this.cpId) {
      let res = await this.summaryService.addMerchantUser(payload);
      this.viewCtrl.dismiss(true);
    }
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/collecion-points/add-cp-user-info/add-cp-user-info-modal.ts